import Router from 'vue-router'
import Vue from 'vue'
import Enroll from '@/components/Enroll.vue'
import Gln from '@/components/Gln.vue'

Vue.use(Router)
const routes = [
  {
    path: '/gln/:idNotion',
    name: 'Gln',
    component: Gln,
    props: true
  },
  {
    path: '/:id',
    name: 'Enroll',
    component: Enroll,
    props: true
  },
  // Sans code ni page connue, Enroll affiche « Aucun code fourni » comme avant
  {
    path: '*',
    component: Enroll
  }
]

const router = new Router({
  routes,
  mode: 'history',
})

export default router